import React, { useEffect } from "react";
import logo from "../../assets/images/Justivide-PrimaryIcon.svg";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import Skeleton from "../../components/ui/Skeleton";

const PrivacyPolicyPublic = () => {
  const cmsPage = useMakeRequest();

  useEffect(() => {
    cmsPage.makeRequest({
      payload: { detail_id: "privacy-policy" },
      url: ApiConstants?.CmsPagesDetail,
    });
  }, []);

  return (
    <div className="cms-public">
      <header role="banner" className="mb-5 text-center">
        <img className="cms-logo" src={logo} alt="Justivide" />
      </header>
      <main id="main-content" className="container">
        {cmsPage?.loading ? (
          <>
            <Skeleton
              className="skeleton-loader mt-5"
              style={{ width: "50%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "60%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "100%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "80%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "90%", height: "20px" }}
            />

            <Skeleton
              className="skeleton-loader mt-5"
              style={{ width: "50%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "60%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "100%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "80%", height: "20px" }}
            />
            <Skeleton
              className="skeleton-loader my-2"
              style={{ width: "90%", height: "20px" }}
            />
          </>
        ) : (
          <div
            className="cms-content"
            dangerouslySetInnerHTML={{
              __html: cmsPage?.data?.data?.content || "",
            }}
          ></div>
        )}
      </main>
    </div>
  );
};

export default PrivacyPolicyPublic;
